<template>
	<div class="guanhuaibox">
<!--		<breadcrumb :routerList="[{to:'/guanhuai',title:'用户交互'},{title:'打卡记录'}]" />-->
    <Breadtabsheader/>
		<!--打卡记录列表-->
		<div class="h-content">
			<div class="h-piece h-mrt30">
				<div class="h-formBox">
					<el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
						<div class="h-thirdColumn w-newColumn">
							<el-form-item label="区域">
								<brselect v-model="q.quyuCode" :v="q.quyuCode" category="YLRegion" :clearable="true"></brselect>
							</el-form-item>
							<el-form-item label="客户名称">
								<el-input v-model="q.customerName" placeholder="请输入"></el-input>
							</el-form-item>
							<el-form-item label="打卡日期" class="timeselect" style="width: 50%;">
								<el-date-picker
									v-model="q.cdateBegin"
									clearable
									type="date"
									value-format="yyyy-MM-dd" >
								</el-date-picker>
								<span class="w-time-to">至</span>
								<el-date-picker
									v-model="q.cdateEnd"
									clearable
									type="date"
									value-format="yyyy-MM-dd" >
								</el-date-picker>
							</el-form-item>
						</div>
						<el-collapse-transition>
							<div v-show="isScreen">
								<div class="h-thirdColumn w-newColumn">
									<el-form-item label="提报人">
										<el-input v-model="q.cuname" placeholder="请输入"></el-input>
									</el-form-item>
									<el-form-item label="抢入链群">
										<el-select filterable v-model="q.lianqunCode" clearable placeholder="请选择"
										>
											<el-option
													v-for="(item,index) in lianqunList"
													:key="item.chainGroupCode"
													:label="item.chainGroupName"
													:value="item.chainGroupCode">
											</el-option>
										</el-select>
									</el-form-item>
                  <el-form-item label="部门">
                    <el-select filterable v-model="q.cdept" clearable placeholder="请选择"
                    >
                      <el-option
                          v-for="(item,index) in deptList"
                          :key="item.dept"
                          :label="item.dept"
                          :value="item.dept">
                      </el-option>
                    </el-select>
                  </el-form-item>
								</div>
							</div>
						</el-collapse-transition>
						<!-- <el-form-item class="h-formBtnOut">
							<el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
							<el-button class="h-btn h-formBtn" @click="reset" style="background-color:white;color:black;border:1px solid #d1d1d1">重置</el-button>
						</el-form-item>
						<el-form-item class="h-formBtnOut">
							<div class="h-listTab">
								<a :class="['h-ltTableIcon',{'h-active':clickActive==1}]" @click="handleTabClick(1)"></a>
								<a :class="['h-ltListIcon',{'h-active':clickActive==2}]" @click="handleTabClick(2)"></a>
							</div>
						</el-form-item> -->
					</el-form>
					<div class="l-screenBox">
						<div class="l-screen" @click="collapseChange">
							<img :src="isScreen?closeScreen:drawScreen" alt="">
							<div class="l-screenText">{{isScreen?"收起":"展开"}}</div>
						</div>
						<div class="l-retrieval">
							<el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
							<el-button class="h-btn h-formBtn h-bgwhite" @click="reset">重置
							</el-button>
							<!--<div class="h-listTab">
								<a :class="['h-ltListIcon',{'h-active':clickActive==1}]" @click="handleTabClick(1)"></a>
								<a :class="['h-ltTableIcon',{'h-active':clickActive==2}]" @click="handleTabClick(2)"></a>
							</div>-->
						</div>
					</div>
				</div>
			</div>
			<!--<div class="h-table h-mrt30" v-if="clickActive==2">
				<el-table ref="multipleTable" @selection-change="handleSelectionChange" :data="tableData2" @header-click="headerClick" :border="true"
				 stripe style="width: 100%" max-height="440">
					<el-table-column type="selection" width="45" label="全选">
					</el-table-column>
					<el-table-column fixed type="index" label="#" width="40">
					</el-table-column>
					<el-table-column prop="areaCode" label="区域" width="80" :show-overflow-tooltip="true">
						<template slot-scope="scope">
							{{scope.row.areaCode | dictname('YLRegion')}}
						</template>
					</el-table-column>
					<el-table-column prop="ghRole" label="角色" width="90" :show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column prop="cuname" label="提报人" width="80" :show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column prop="euName" label="客户名称" min-width="180" :show-overflow-tooltip="true">
						<template slot-scope="scope">
							<div style="text-align: left;">
								{{scope.row.euName}}
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="planRemark" label="拜访内容" :show-overflow-tooltip="true" width="180">
						<template slot-scope="scope">
							<div style="text-align: left;">
								{{scope.row.planRemark}}
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="result" label="拜访结果" :show-overflow-tooltip="true" min-width="180">
						<template slot-scope="scope">
							<div style="text-align: left;">
								{{scope.row.result}}
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="careTime" sortable label="拜访日期" width="110">
					</el-table-column>
					<el-table-column prop="contact" label="联系人" width="80" :show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column prop="contactDept" label="部门/科室" width="100" :show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column prop="contactPhone" label="联系电话" width="120" :show-overflow-tooltip="true">
						<template scope="scope">
						    <div style="text-align: left;">
								{{scope.row.contactPhone}}
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="exeAgentName" label="跑动经销商" width="180" :show-overflow-tooltip="true">
						<template slot-scope="scope">
							<div style="text-align: left;">
								{{scope.row.exeAgentName}}
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="prodseries" label="产品大类" width="100" :show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column prop="promodel" label="产品型号" width="160" :show-overflow-tooltip="true">
						<template slot-scope="scope">
							<div style="text-align: left;">
								{{scope.row.promodel}}
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="proPrice" label="单价" width="80" :show-overflow-tooltip="true">
						<template slot-scope="scope">
							<div style="text-align: right;">
								{{scope.row.proPrice}}
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="proNumber" label="数量" width="80" :show-overflow-tooltip="true">
						<template slot-scope="scope">
							<div style="text-align: right;">
								{{scope.row.proNumber}}
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="proTotalAmount" label="合计" width="80" :show-overflow-tooltip="true">
						<template slot-scope="scope">
							<div style="text-align: right;">
								{{scope.row.proTotalAmount}}
							</div>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="160" fixed="right">
						<template slot-scope="scope">
							<div style="text-align: left;">
								<el-button type="text" size="small" class="h-tableLink h-btn" @click="saveJingPin(scope.row.id)" v-if="scope.row.cucode == nowcucode">
									竞品维护
								</el-button>
								<el-button type="text" size="small" class="h-tableLink h-btn" @click="checkDetail2(scope.row.id)">
									查看
								</el-button>
							</div>
							
							&lt;!&ndash; <div class="l-operationBox">
								<span class="l-operationlist br-operation-jpwh" v-if="scope.row.cucode == nowcucode" title="竞品维护" @click="saveJingPin(scope.row.id)"></span>
								<span class="l-operationlist br-operation-look" title="查看" @click="checkDetail2(scope.row.id)"></span>
							</div> &ndash;&gt;
						</template>
					</el-table-column>
				</el-table>
				<div class="h-tableB h-mrt30">
					<div class="h-tableBL" v-auth="'pljhan'">
						<el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" v-if="daochu" @click="exportExcel">批量导出</el-button>
						<el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export" @click="uploaddownexcelflagbtn">批量导入</el-button>
						<uploaddownexcel :visible.sync="uploaddownexcelflag" v-if="uploaddownexcelflag" clsname="ghexecutionImportExcel"
						 :startrow="3" @callback="uploadExcelFilecallback" />
						<el-button class="h-btn h-formBtn h-bgblueQ" @click="deleteExe">批量删除</el-button>
					</div>
					<div class="h-pagination2">
						<paginationmincopy :page="q" @query="query" />
					</div>
				</div>
			</div>-->
			<div v-if="clickActive==1">
				<div class="h-piece h-mrt30">
					<div class="h-tableList">
						<div class="h-tableListin">
							<ul>
								<li v-for="(item,index) in tableData2" :key="index">
									<div class="h-tableListItem">
										<div class="h-tListItemT" style="margin-bottom: 0.2rem">
											<div class="h-tListItemTopL">
												<p>{{item.punchTime.split(" ")[0]}}</p>
												<span>{{item.punchTime.split(" ")[1]}}</span>
											</div>
											<div class="h-tListItenTopR" style="margin-top:-10px;">
												<span>提报人：</span>
												<span>{{item.cuname}}</span>
											</div>
										</div>
										<div class="h-rdFormWrap" style="width:100%;text-align:left;height: auto">
											<p class="h-grayFont">交互图片</p>
											<i v-if="item.saveurl != '1'">
												<el-image
													style="width: 3.1rem;height: 2.0rem;"
													:src="item.saveurl"
													:preview-src-list="srcList">
												</el-image>
											</i>
											<i v-if="item.saveurl == '1'">
												<img src="../../../assets/images/mylittle.png"
												 style="width: 3.1rem;height: 2.0rem;"></i>
										</div>
										<p class="h-tListTxt h-mrt20" :title="item.customerName" style="width:220px; overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">客户名称：{{item.customerName}}</p>
										<p class="h-tListTxt h-mrt20" :title="item.punchPlace" style="width:220px; overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">拜访地点：{{item.punchPlace}}</p>
										<p class="h-tListTxt h-mrt20" :title="item.lianqunName" style="width:220px; overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">抢入链群：{{item.lianqunName}}</p>
                    <p class="h-tListTxt h-mrt20" :title="item.deptName" style="width:220px; overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">部门：{{item.deptName}}</p>
										<!--<div class="h-txtCenter h-mrt25">
											<el-button class="h-btn h-formBtn h-bgblueQ" @click="checkDetail2(item.id)">查看详情</el-button>
										</div>-->
									</div>
								</li>
							</ul>
						</div>
					</div>
					
				</div>
				<div style="margin-top: 0.3rem;">
					<paginationmincopy :page="q" @query="query" />
				</div>
			</div>
			
		</div>
		<!--打卡记录详情-->
		<el-dialog :close-on-click-modal="false" title="查看详情" :visible.sync="dialogFormVisible6" class="h-dialog">
			<div class="h-runningDetail" style="border-top:0;padding:0.32rem;padding-left: 0.5rem;">
				<div class="h-rdTitle">
					<h1>{{qdetail1.euName}}</h1>
					<label>已拜访</label>
				</div>
				<div class="h-rdForm">
					<div class="h-rdFormWrap" style="width:100%;height:0.5rem">
						<p class="h-grayFont" style="display:inline-block;margin-right:0.3rem">拜访时间</p>
						<p style="display:inline-block">{{qdetail1.cdate}}</p>
					</div>
					<div class="h-rdFormWrap" style="text-align:left;">
						<p class="h-grayFont">负责人</p>
						<p>{{qdetail1.contact}}</p>
					</div>
					<div class="h-rdFormWrap">
						<p class="h-grayFont">部门/科室</p>
						<p>{{qdetail1.contactDept}}</p>
					</div>
					<div class="h-rdFormWrap" style="padding-left: 1.2rem;box-sizing:border-box;text-align:center">
						<p class="h-grayFont">拜访对象</p>
						<div v-if="qdetail1.euType">
							<p>
								<dictname category="DaKaJiLuType" :v="qdetail1.euType" />
							</p>
						</div>
					</div>
					<div class="h-rdFormWrap" style="text-align:left;">
						<p class="h-grayFont">联系方式</p>
						<p>{{qdetail1.contactPhone}}</p>
					</div>
					<div class="h-rdFormWrap">
						<p class="h-grayFont" style="color:#fff">&nbsp;</p>
					</div>
					<div class="h-rdFormWrap">
						<p class="h-grayFont" style="color:#fff">&nbsp;</p>
					</div>
					<div class="h-rdFormWrap" style="width:100%;text-align:left;">
						<p class="h-grayFont">洽谈内容</p>
						<el-input type="textarea" maxlength="200" :value="qdetail1.planRemark" readonly></el-input>
						<!-- <p>{{qdetail.planRemark?qdetail.planRemark:''}}</p> -->
					</div>
					<div class="h-rdFormWrap" style="width:100%;text-align:left;">
						<p class="h-grayFont">洽谈结果</p>
						<p :title="qdetail1?qdetail1.result:''">{{qdetail1?qdetail1.result:''}}</p>
					</div>
					<div class="h-rdFormWrap" style="width:100%;text-align:left;height: auto">
						<p class="h-grayFont">交互图片</p>
						<ul>
							<li v-for="(item,index) in PhotoList" :key="index">
                <el-image
                    style="width: 0.6rem;height: 0.6rem;"
                    :src="item.saveurl"
                    :preview-src-list="srcList">
                </el-image>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button class="h-btn h-bBtn " :class="[qdetail1.cucode==nowcucode&&qdetail1.transform==0?'h-bgwhite':'h-bgblueQ2']" @click="dialogFormVisible6 = false">取消</el-button>
				<el-button v-if="qdetail1.cucode==nowcucode&&qdetail1.transform==0" class="h-btn h-formBtn h-bgblueQ2" @click="zhuanhuaxuqiu">一键转化需求</el-button>
			</div>
		</el-dialog>
    <div class="h-tableB h-mrt30" style="margin-left: 27px">
      <div class="h-tableBL">
        <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="exportExcelWhl">批量导出</el-button>
      </div>
    </div>
	</div>
</template>

<script>
	import ss from '../../../api/SystemService'
	import updownfile from '../../../utils/updownfile'
	import uploadexcel from '../../../components/uploaddown/uploadexcel'
	import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel'
	export default {
		components: {
			uploaddownexcel,
			uploadexcel
		},
		data() {
			return {
				// 展开折叠筛选
				isScreen:false,
				closeScreen:require("@/assets/images/pimg/closeallic.png"),
				drawScreen:require("@/assets/images/pimg/dobleArr.png"),
				nowcucode:'',
				status: 1,
				showOrhide: false,
				checked: true,
				toshow: "guanhuai",
				daochu: false,
				value2: '',
				PhotoList: [],
        		srcList:[],//交互图片预览集合
				//上传
				uploaddownexcelflag: false,
				//弹框-管理员跑动吻合率
				whldialogFlag: false,
				q2: {
					pageSize: 10,
					pageNo: 1,
					total: 0,
				},
				sumRank: [],
				blank1_1: false,
				blank1_2: false,
				blank2: false,
				care: {},
				jxDayData: "",
				jxDayValue: "",
				jxDayRank: "无",
				jxDayWidth: "0%",
				jxMonthData: "",
				jxMonthValue: "",
				jxMonthRank: "无",
				jxMonthWidth: "0%",
				paidex: 0,
				paiminglist: ['当天排名', '当月排名'],
				xuqiuList: ['资源需求', '信息获取'],
				xuqiudex: 0,
				//提报原因
				dialogFormVisible1: false,
				//修改计划
				dialogFormVisible2: false,
				//详情查看
				dialogFormVisible3: false,
				dialogFormVisible6: false,
				dialogFormVisible4: false,
				planBoxlist: false,
				planlists: [{
					active: 0,
					title: '青岛大学附属医院血液柜拜访',
					baifang: '常规拜访',
					time: '11:30~12:30',
				}],
				dialogFormVisible: false,
				formLabelAlign2: [{}],
				formLabelAlign3: {},
				rules2: {
					// formCon1: [
					// 	{ required: true, message: '', trigger: 'blur' },
					// ],
					euType: [{
						required: true,
						message: '请选择客户类型',
						trigger: 'blur'
					}, ],
					euCode: [{
						required: true,
						message: '请选择拜访客户',
						trigger: 'blur'
					}, ],
					planTimeStart: [{
						required: true,
						message: '请选择拜访时间',
						trigger: 'blur'
					}, ],
					planTimeEnd: [{
						required: true,
						message: '请选择拜访时间',
						trigger: 'blur'
					}, ],
					remark: [{
						required: true,
						message: '请输入过期原因',
						trigger: 'blur'
					}, ],
					// formCon9:[
					// 	{ required: true, message: '联系方式不能为空' ,trigger: 'blur' },
					// 	{ type: 'number', message: '联系方式必须为数字值', trigger: 'blur' }
					// ]
				},
				f: {
					userName: null,
				},
				EuName: [],
				qdetail: {},
				qdetail1: {},
				options1: [],
				options2: [],
				optionsCustomer: [],
				optionsAgent: [],
				optionsArea: [],
        deptList: [],
				tdate: new Date(),
				calenderValue: new Date(),
				yearOptions: [{
					value: '2017',
					label: '2017'
				}, {
					value: '2018',
					label: '2018'
				}, {
					value: '2019',
					label: '2019'
				}, {
					value: '2020',
					label: '2020'
				}],
				monthOptions: [{
					value: '1',
					label: '1月'
				}, {
					value: '2',
					label: '2月'
				}, {
					value: '3',
					label: '3月'
				}, {
					value: '4',
					label: '4月'
				}, {
					value: '5',
					label: '5月'
				}, {
					value: '6',
					label: '6月'
				}, {
					value: '7',
					label: '7月'
				}, {
					value: '8',
					label: '8月'
				}, {
					value: '9',
					label: '9月'
				}, {
					value: '10',
					label: '10月'
				}, {
					value: '11',
					label: '11月'
				}, {
					value: '12',
					label: '12月'
				}],
				yearValue: new Date().getFullYear() + "年",
				monthValue: new Date().getMonth() + 1 + "月",
				headnum: {
					plansum: 0,
					plandone: 0,
					planmatch: 0,
					grade: '',
					rqId: null
				},
				//表单
				q: {
					demandflag: false,
					cdateEnd: null,
					cdateBegin: null,
					lianqunCode: null,
					pageSize: 8,
					pageNo: 1,
					total: 0,
				},
				//表单上面日历点击后页面
				q1: {
					pageSize: 4,
					pageNo: 1,
					total: 0,
				},
				//表格
				multipleSelection: [],
				lianqunList : [],
				tableData2: [],
				clickActive: 1,
				//日历
				calenderData: [],
				planList: [{}],
				detailDayString: "",
				executionId: null,
			}
		},
		methods: {
			// 展开折叠
			collapseChange(){
				this.isScreen = !this.isScreen;
			},
			//是否展示新手引导
			/*showzhezhao(){
				ss.salesList.toshow(this.toshow).then(rd => {
					console.log(rd)
				    if(rd == false){
				        this.showOrhide = false;
				    }else{
				        this.showOrhide = true;
				    }
				})
			},*/
			timeSelect() {
				this.q.cdateBegin = this.value2[0];
				this.q.cdateEnd = this.value2[1];
			},
			getimgId(id) {
                this.PhotoList.push({
                    saveurl: this.$baseurl+'/api/file/fileopt/showImg?id='+id,
                })
        		this.srcList.push(this.$baseurl+'/api/file/fileopt/showImg?id='+id);
				// ss.DaKaJiLu.imgDown(id).then(data => {
				// 	var imgbase = 'data:image/png;base64,' + btoa(new Uint8Array(data.data).reduce((data, byte) => data + String.fromCharCode(
				// 		byte), ''))
				// 	if (imgbase) {
				// 		this.PhotoList.push({
				// 			saveurl: imgbase,
				// 		})
				// 	}
				// })
			},
			uploadExcelFilecallback(rd) {
				//this.$msg.alert(rd);
			},
			uploaddownexcelflagbtn() {
				this.uploaddownexcelflag = true;
			},
			tab2(index) {
				this.paidex = index;
				this.lineChart1(index);
			},
			//日历点击这个时间，日历点击那天的时间
			selecttime(times) {
				this.q1.pageNo = 1;
				this.selecttimeQ(times);
			},
			//翻页
			selecttimeQ(times) {
				// console.log(this.$util.riQi3(this.tdate))
				this.detailDayString = times;
				//交互计划详情\
				this.q1.planTimeEndEnd = times
				this.q1.planTimeStartBegin = times
				ss.DaKaJiLu.selectPage(this.q1).then(rd => {
					this.q1.total = rd.total;
					this.planlists = rd.records;
					if (this.planlists && this.planlists.length > 0) {
						this.planlists.forEach((item, index) => {
							if (item.planTimeEnd > this.$util.riQi3(this.tdate) && !item.executionId && (item.planStatus == 2 || item.planStatus ==
									6)) {
								//今天之前没有执行的计划
								item.active = 1;
							}
							if (item.planTimeEnd < this.$util.riQi3(this.tdate) && !item.executionId) {
								//今天之后没有执行的计划
								item.active = 2;
							}
							if (item.executionId) {
								item.active = 0;
							}
							if (this.$store.getters.hasRole("swyl_guanhgly")) {
								item.active = 9;
							}
						})
					}
				})
				this.planBoxlist = true;
			},
			customerType(v) {
				this.formLabelAlign3.euCode = null;
				this.formLabelAlign3.euName = null;
				this.formLabelAlign3.channelCode = null;
				this.formLabelAlign3.areaCode = null;
				this.formLabelAlign3.contactDept = null;
				this.formLabelAlign3.contact = null;
				this.formLabelAlign3.contactPhone = null;
				this.EuName = null;
			},
			//下拉框选中事件
			showForm(v) {
				let obj = {};
				obj = this.EuName.find((item) => { //这里的userList就是上面遍历的数据源
					return item.userName === v; //筛选出匹配数据
				});
				this.formLabelAlign3.euCode = obj.userCode; //我这边的name就是对应label的
				this.formLabelAlign3.contactDept = obj.department ? obj.department : '';
				this.formLabelAlign3.contact = obj.contactuserName ? obj.contactuserName : '';
				this.formLabelAlign3.contactPhone = obj.telephone ? obj.telephone : '';
			},
			gundong() {
				document.documentElement.scrollTop = 840;
			},
			//通过用户名带出详细信息
			showFormList(value) {
				this.f.userName = value;
				if (this.formLabelAlign3.euType == 1) {
					ss.DaKaJiLu.agentOption(this.f).then(rd => {
						this.EuName = rd;
					})
				} else if (this.formLabelAlign3.euType == 2) {
					ss.DaKaJiLu.customerOption(this.f).then(rd => {
						this.EuName = rd;
					})
				}
			},
			tibaobut(item) {
				this.dialogFormVisible1 = true;
				ss.DaKaJiLu.planDetail({
					id: item
				}).then(rd => {
					this.formLabelAlign3 = rd.plan;
				})
			},
      getDept(q){
        ss.MuBiao.getDeptList(q).then(rd => {
          this.deptList = rd;
        })
      },
			editorplan(item) {
				this.dialogFormVisible2 = true;
				ss.DaKaJiLu.planDetail({
					id: item
				}).then(rd => {
					this.formLabelAlign3 = rd.plan;
				})
			},
			handleSizeChange() {},
			handleCurrentChange() {},
			//表格
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},

			headerClick() {},
			//切换列表
			handleTabClick(a) {
				if (a == this.clickActive) {
					return
				} else {
					this.clickActive = a
				}
			},
			//我的日程年的切换
			handleYearClick() {
				this.calenderValue = (this.yearValue + "-" + this.monthValue).split("月")[0]
				this.queryAgenda();
			},
			//我的日程月的切换
			handleMonthClick() {
				this.calenderValue = this.yearValue.split("年")[0] + "-" + this.monthValue
				this.queryAgenda();
			},
			handleDateClick(a) {
				this.yearValue = a.getFullYear() + "年";
				this.monthValue = a.getMonth() + 1 + "月"
			},
			lineChart() {
				let lineChart = this.$echarts.init(document.getElementById('h_lineChart'));
				let option = {
					grid: {
						top: "20px",
						left: "0px",
						right: "10px",
						bottom: "40px"
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							show: true,
							lineStyle: {
								color: '#61a0f7'
							}
						}
					},
					legend: {
						show: false
					},
					calculable: true,
					xAxis: [{
						type: 'category',
						data: [],
						axisLine: {
							show: false
						},
						splitLine: {
							show: false
						},
						axisTick: {
							show: false
						},
						axisLabel: {
							show: true,
							color: '#b9b9b9',
							fontFamily: 'Microsoft YaHei',
							fontSize: 18
						}
					}],
					yAxis: [{
						type: 'value',
						axisLine: {
							show: false
						},
						splitLine: {
							show: false
						},
						axisTick: {
							show: false
						},
						axisLabel: {
							show: false
						}
					}],
					series: [{
						name: '跑动排名',
						type: 'line',
						symbol: 'circle',
						symbolSize: 0,
						showSymbol: false,
						areaStyle: {
							color: {
								type: 'linear',
								x: 0,
								y: 0,
								x2: 0,
								y2: 1,
								colorStops: [{
									offset: 0,
									color: 'rgba(145,188,250,1)' // 0% 处的颜色
								}, {
									offset: 0.5,
									color: 'rgba(145,188,250,0.5)' // 0% 处的颜色
								}, {
									offset: 1,
									color: 'rgba(145,188,250,0)' // 100% 处的颜色
								}],
								globalCoord: false // 缺省为 false
							},
						},
						smooth: true,
						data: [],
						lineStyle: {
							color: '#61a0f7'
						},
						itemStyle: {
							normal: {
								color: '#ffffff',
								borderColor: '#61a0f7',
								borderWidth: 2
							}
						}
					}]
				};
				lineChart.setOption(option);
			},
			lineChart1(index) {
				var jxDayRank = this.jxDayRank;
				var jxMonthRank = this.jxMonthRank;
				let lineChart1 = this.$echarts.init(document.getElementById('h_barChart'));
				var dataAxis = [];
				var data = [];
				var dataShadow = [];
				let option = {
					grid: {
						top: "20px",
						left: "10px",
						right: "10px",
						bottom: "40px"
					},
					xAxis: {
						show: false,
						data: dataAxis,
						axisLabel: {
							inside: true,
							textStyle: {
								color: '#fff'
							}
						},
						axisTick: {
							show: false
						},
						axisLine: {
							show: false
						},
						z: 10
					},
					yAxis: {
						show: false,
						axisLine: {
							show: false
						},
						axisTick: {
							show: false
						},
						axisLabel: {
							textStyle: {
								color: '#999'
							}
						}
					},
					dataZoom: [{
						type: 'inside'
					}],
					series: [{ // For shadow
							type: 'bar',
							barWidth: "5%",
							barGap: "10%",
							itemStyle: {
								normal: {
									color: 'rgba(0,0,0,0.05)',
									barBorderRadius: 5,
								}
							},
							barGap: '-100%',
							barCategoryGap: '40%',
							data: dataShadow,
							animation: false
						},
						{
							type: 'bar',
							itemStyle: {
								normal: {
									// color: '#61a8fd',
									color: function(params) {
										if ((index == 0 && params.dataIndex + 1 == jxDayRank) || (index == 1 && params.dataIndex + 1 ==
												jxMonthRank)) {
											return '#F4A82D';
										} else {
											return '#61a8fd';
										}
									},
									barBorderRadius: 5,
								}
							},
							data: data
						}
					]
				};
				lineChart1.setOption(option);
				if (index == 0) {
					lineChart1.setOption({
						xAxis: {
							data: this.jxDayData
						},
						series: [{
								name: 'shadow',
								data: this.jxDayValue
							},
							{
								name: 'bar',
								data: this.jxDayValue
							}
						]
					})
				} else {
					lineChart1.setOption({
						xAxis: {
							data: this.jxMonthData
						},
						series: [{
								name: 'shadow',
								data: this.jxMonthValue
							},
							{
								name: 'bar',
								data: this.jxMonthValue
							}
						]
					})
				}
			},
			query() {
				console.log(this._user.usercode,"99999999999999")
				this.daochu = this.$store.getters.hasRole("swyl_admin,swyl_guanhgly");
				ss.DaKaJiLu.allexec(this.q).then(rd => {
				  let _this = this;
					this.q.total = rd.total;
					this.tableData2 = rd.records;
					this.tableData2.forEach((elememts,index) => {
						elememts.saveurl = elememts.fileid;
                        _this.srcList.push(elememts.fileid)
					});
				})
			},
			/*pdwhllist() {
				//跑动吻合率列表
				ss.DaKaJiLu.whlPage(this.q2).then(rd => {
					//查询这一天的用户人数，审核情况等
					this.whldialogFlag = true;
					console.log("跑动吻合率列表===", rd);
					this.sumRank = rd.records;
					this.q2.total = rd.total;

				})
			},*/
			queryAgenda() {
				ss.DaKaJiLu.allplan({
					year: this.yearValue.split("年")[0],
					month: this.monthValue.split("月")[0]
				}).then(rd => {
					this.calenderData = rd.plans;
				})
			},
			handleFilter() {
				this.query();
			},
			/*checkDetail(item) {
				//查看详情
				this.dialogFormVisible3 = true
				ss.DaKaJiLu.planDetail({
					id: item
				}).then(rd => {
					this.qdetail = rd.plan;
					console.log(this.qdetail,"11111111111111111111")
					this.PhotoList = [];
					if (rd.plan.DaKaJiLuExecution.carePhoto) {
						for (var i = 0; i < rd.plan.DaKaJiLuExecution.carePhoto.length; i++) {
							this.getimgId(rd.plan.DaKaJiLuExecution.carePhoto[i].id)
						}
					}
				})
			},*/
			saveJingPin(value) {
				this.$router.push({
					path: "/presentation1",
					query: {
						id: value
					}
				});
			},
			checkDetail2(item) {
				//下面列表的查看详情
				this.dialogFormVisible6 = true;
				this.executionId = item;
				/*ss.DaKaJiLu.planDetail2({
					executionId: item
				}).then(rd => {
					this.qdetail1 = rd.plan.DaKaJiLuExecution;
					console.log(this.qdetail1,"222222222222222")
					this.PhotoList = [];
					if (rd.plan.DaKaJiLuExecution.carePhoto) {
						for (var i = 0; i < rd.plan.DaKaJiLuExecution.carePhoto.length; i++) {
							this.getimgId(rd.plan.DaKaJiLuExecution.carePhoto[i].id)
						}
					}
				})*/
			},
			//批量删除
			deleteExe() {
				var idlist = [];
				this.multipleSelection.forEach(element => {
					idlist.push(element.id);
				});
				this.$msg.confirm("确认删除?", () => {
					ss.DaKaJiLu.deleteExe(idlist).then(rd => {
						this.$msg.msgs(rd.msg);
						this.query();
					});
				});
			},
			//明细导出
			exportExcel() {
				var idlist = [];
				this.multipleSelection.forEach(element => {
					idlist.push(element.id);
				});
				this.q.ids = idlist
				updownfile.down("/api/swyl/v1/guanhuai/DaKaJiLuExecution/downloadExcel", this.q, "post", 'data');
			},
			//明细导出
			exportExcelWhl() {
				updownfile.down("/api/swyl/v1/dakajilu/userPunchingCardRecord/downloadExcel", this.q, "post", 'data');
			},
			//导入
			beforeUpload(file) {
				updownfile.uploadExcel("/api/swyl/v1/guanhuai/DaKaJiLuExcel/uploadExcel", file).then(rd => {}).catch(error => {
					return Promise.reject(error);
				})
				return false;
			},
			addplanList() {
				var a = {}
				this.planList.push(a)
			},
			delplanList() {
				this.planList.splice(0, 1)
			},
			addplan() {
				this.dialogFormVisible = true;
			},
			addweek() {
				//创建周计划，查询当前用户下周计划状态
				var planstatus = 0;
				ss.DaKaJiLu.weekPlanStatus().then(rd => {
					if (rd.obj && rd.obj.length > 0) {
						planstatus = rd.obj[0].planStatus;
						if (planstatus == 1) {
							this.$msg.msge("周计划已提交，请等待审核");
						} else if (planstatus == 2) {
							this.$msg.msge("周计划已生成，请勿重复操作");
							// this.$message({
							// 	message: '周计划已生成，请勿重复操作',
							// 	type: 'warning'
							// });
						} else {
							this.$router.push("/weekplan");
						}
					} else {
						this.$router.push("/weekplan");
					}
				})
			},
			/*gotoxuqiu() {
				console.log(this.xuqiudex)
				if (this.xuqiudex == 0) {
					this.$router.push({
						path: '/transforming_demand2',
						query: {
							id: this.executionId
						}
					})
					this.dialogFormVisible1 = false;
				} else if (this.xuqiudex == 1) {
					this.$router.push({
						path: '/transforming_demand1',
						query: {
							id: this.executionId
						}
					})
					this.dialogFormVisible1 = false;
				}
			},*/
			/*zhuanhuaxuqiu() {
				this.dialogFormVisible4 = true;
			},*/
			/*xuqiuGo(index) {
				this.xuqiudex = index;
			},*/
			reset() {
				this.q = {
					lianqunCode: null,
					pageSize: this.q.pageSize,
					pageNo: this.q.pageNo,
					total: this.q.total
				}
			},
			/*submitReasonOrChange(v) {
				//过期未执行提报原因
				let msg = "确认修改计划？";
				var subflag = true;
				if (v == 1) {
					msg = "确认提报原因？";
					if (!this.formLabelAlign3.remark) {
						this.$msg.msge("请填写提报原因");
						this.$refs['formLabelAlign3'].validate((valid) => {
							return valid;
						})
						subflag = false;
					}
					this.formLabelAlign3.planStatus = 4; //提交
				} else {
					//修改计划
					this.formLabelAlign3.planStatus = 2; //提交
				}
				if (subflag) {
					this.$msg.confirm(msg, () => {
						ss.DaKaJiLu.updateById(this.formLabelAlign3).then(rd => {
							this.$msg.msgs("提交成功");
							this.dialogFormVisible1 = false;
							this.dialogFormVisible2 = false;
						})
					})
				}
			},*/
			/*getHead() {
				ss.DaKaJiLu.headline({}).then(rd => {
					if (rd.f) {
						this.headnum.headnum = rd.planHead.sum;
						this.headnum.headdone = rd.planHead.done;
						this.headnum.headmatch = rd.planHead.match;
						this.headnum.grade = rd.planHead.grade;
						this.headnum.rqId = rd.planHead.rqId;
					}
					console.log("头部的值", this.headnum);
				})
			},*/
			//时间限制
			beginDate(v) {
				if (v.planTimeEnd) { //如果结束时间不为空，则小于结束时间
					if (v.planTimeEnd < v.planTimeStart) {
						this.$msg.msge("结束日期不能小于开始日期");
						v.planTimeStart = "";
					}
				}
			},
			processDate(v) {
				if (v.planTimeStart) { //如果有出厂日期
					//如果购买日期小于出厂日期
					if (v.planTimeEnd < v.planTimeStart) {
						this.$msg.msge("结束日期不能小于开始日期");
						v.planTimeEnd = "";
					}
				}
			},
			//获取抢入链群信息
			getAllLianqun(){
				ss.createMonthGoal.getAllLianqun().then(rd => {
					this.lianqunList = rd;
				})
			},
			/*// 关闭新手引导页
			closeIt() {
				this.showOrhide = false;
				if (this.checked) {
					ss.salesList.toshow(this.toshow,this.checked).then(rd => {
						console.log(rd)
						this.showOrhide = false;
					})
				}else{
					ss.salesList.toshow(this.toshow,this.checked).then(rd => {
						console.log(rd)
						this.showOrhide = false;
					})
				}
			},*/
			/*nextStep(i) {
				if (this.status == 1) {
						this.status = 2;
				} else if (this.status == 2) {
						this.status = 3;
				} else if (this.status == 3) {
						this.status = 4;
				} else if (this.status == 4) {
						this.status = 5;
				} else if (this.status == 5) {
						this.status = 6;
						document.documentElement.scrollTop = 180;
				} else if (this.status == 6) {
						this.status = 7;
						document.documentElement.scrollTop = 480;
				} else if (this.status == 7) {
						this.status = 8;
				} else if (this.status == 8) {
						this.status = 9;
						document.documentElement.scrollTop = 1200;
				} else if (this.status == 9) {
					if (this.checked) {
						ss.salesList.toshow(this.toshow,this.checked).then(rd => {
							console.log(rd)
							this.showOrhide = false;
						})
					} else {
						ss.salesList.toshow(this.toshow,this.checked).then(rd => {
							console.log(rd)
							this.showOrhide = false;
						})
					}
				}
			},*/

		},
		mounted() {

			/*this.lineChart();
			this.lineChart1();*/
			this.query();
			/*//跑动排行
			ss.firstPageService.getDaKaJiLuRanking().then(rd => {
				var careData = [];
				var careValue = [];
				if (rd.careList != null && rd.careList.length > 0) {
					for (var i = 0; i < rd.careList.length; i++) {
						var cl = rd.careList[i];
						careData.push(cl.orderDate);
						careValue.push(cl.orderNo);
					}
					this.care = rd.care;
					let lineChart = this.$echarts.init(document.getElementById('h_lineChart'));
					lineChart.setOption({
						xAxis: [{
							type: 'category',
							data: careData
						}],
						series: [{
							type: 'line',
							data: careValue
						}]
					})
				} else {
					this.blank2 = true;
				}
			});*/
			/*//绩效排行,当天
			ss.firstPageService.getJiXiaoRanking({
				type: 'day'
			}).then(rd => {
				var cuser = rd.cuser;
				var jxData = [];
				var jxValue = [];
				if (rd.list != null && rd.list.length > 0) {
					for (var i = 0; i < rd.list.length; i++) {
						var cl = rd.list[i];
						jxData.push(cl.cuname);
						jxValue.push(cl.proTotalAmount);
						if (cuser == cl.cuname) {
							this.jxDayRank = parseInt(cl.id);
							this.jxDayWidth = (rd.list.length - cl.id + 1) * 100 / rd.list.length + '%';
						}
					}
					this.jxDayData = jxData;
					this.jxDayValue = jxValue;
					this.lineChart1(0);
				} else {
					this.blank1_1 = true;
				}
			});
			//绩效排行,当月
			ss.firstPageService.getJiXiaoRanking({
				type: 'month'
			}).then(rd => {
				var cuser = rd.cuser;
				var jxData = [];
				var jxValue = [];
				if (rd.list != null && rd.list.length > 0) {
					for (var i = 0; i < rd.list.length; i++) {
						var cl = rd.list[i];
						jxData.push(cl.cuname);
						jxValue.push(cl.proTotalAmount);
						if (cuser == cl.cuname) {
							this.jxMonthRank = parseInt(cl.id);
							this.jxMonthWidth = (rd.list.length - cl.id + 1) * 100 / rd.list.length + '%';
						}
					}
					this.jxMonthData = jxData;
					this.jxMonthValue = jxValue;
				} else {
					this.blank1_2 = true;
				}
			});*/

		},
		created() {
			/*this.showzhezhao()
			this.queryAgenda();*/
			/*this.getHead();*/
			this.options2 = this.$store.getters.dicts["DaKaJiLuType"];
			this.nowcucode = this._user.usercode;
			this.getAllLianqun();
			this.getDept();
		}
	}
</script>

<style scoped>
	.h-dialogForm .h-elformWrap-1 {
		margin-bottom: 0.2rem;
	}

	.textBox {
		margin-left: 20px;
		margin-top: -10px;
	}

	.textBox span {
		color: #bec3c4;
		font-size: 16px;
		margin-left: 30px;
	}

	.textBox span:first-child {
		margin: 0;
	}

	.selecBox {
		display: flex;
	}

	.selecBox .button {
		width: 85px;
		height: 32px;
		color: #767676;
		text-align: center;
		line-height: 28px;
		border: 1px solid #dddfe4;
		background: #fff;
		cursor: pointer;
		font-size: 0.16rem;
	}

	.selecBox .button.active {
		background: #2686e7;
		color: #fff;
		border-color: #2686e7;
	}

	.paimingBox {
		margin-top: 50px;
		display: flex;
		flex-direction: column;
		margin-left: 10px;
	}

	.paimingBox .title {
		font-size: 14px;
		color: #c6ced1;
		margin-bottom: 10px;
	}

	.paimingBox .borderBox {
		height: 12px;
		border-radius: 6px;
		background: #def2ff;
		position: relative;
	}

	.paimingBox .borderBox .borders {
		position: absolute;
		width: 20%;
		height: 12px;
		border-radius: 6px;
		background: #5aabff;
	}

	.planList {
		margin-top: 40px;
	}

	.planList:first-child {
		margin-top: 0
	}

	.planBoxzhezhao {
		width: 100%;
		height: 7.2rem;
		background: rgba(0, 0, 0, 0.3);
		position: absolute;
		top: 10px;
		left: 0;
		box-sizing: border-box;
	}

	.planBoxs {
		width: 90%;
		height: 90%;
		background: #fff;
		border: 1px solid #c4c4c4;
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		margin: auto;
		padding: 40px 40px 20px 40px;
		box-sizing: border-box;
	}

	.planBoxs .planBoxtop {
		font-size: 18px;
		color: #282828;
	}

	.planBoxs .planBoxcenter {
		margin-top: 10px;
	}

	.planBoxs .planBoxcenter .planBoxcenterlist {
		display: flex;
		justify-content: space-between;
		align-items: center;
		height: 60px;
		border-bottom: 1px solid #eee;
	}

	.planBoxs .planBoxcenter .planBoxcenterlist .divs {
		width: 16.666%;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		text-align: center;
	}

	.planBoxs .planBoxcenter .planBoxcenterlist .yellowtext {
		width: 61px;
		height: 29px;
		background-color: #fbdfc8;
		border-radius: 15px;
		font-size: 14px;
		color: #ee9433;
		text-align: center;
		line-height: 29px;
	}

	.planBoxs .planBoxcenter .planBoxcenterlist .centertext {
		font-size: 14px;
		color: #323232;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.planBoxs .planBoxcenter .planBoxcenterlist .baifantext {
		font-size: 14px;
		color: #a7a7a7;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.planBoxs .planBoxcenter .planBoxcenterlist .timetext {
		font-size: 14px;
		color: #a7a7a7;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.planBoxs .planBoxcenter .planBoxcenterlist .nullwan {
		width: 74px;
		height: 29px;
		border-radius: 15px;
		border: solid 1px #ee9433;
		font-size: 14px;
		color: #ee9433;
		text-align: center;
		line-height: 29px;
	}

	.planBoxs .planBoxcenter .planBoxcenterlist .editortext {
		width: 67px;
		height: 29px;
		background-color: #3e99f2;
		border-radius: 15px;
		font-size: 14px;
		color: #fff;
		text-align: center;
		line-height: 29px;
		cursor: pointer;
		margin-left: 15px;
	}

	.planBoxs .planBoxcenter .planBoxcenterlist .chakan {
		font-size: 14px;
		color: #3e99f2;
		text-align: center;
		cursor: pointer;
	}

	.planBoxs .planBoxbottom {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.backtext {
		width: 80px;
		height: 26px;
		background-color: #3e99f2;
		border-radius: 5px;
		text-align: center;
		line-height: 26px;
		color: #fff;
		font-size: 14px;
		cursor: pointer;
		margin-top: 0.2rem;
	}

	.h-calendarSelect .h-selectLine {
		display: inline-block;
		vertical-align: middle;
		margin-left: 0.30rem;
		margin-right: 0.12rem;
		font-size: 0.22rem;
		color: #2381e8;
	}

	.yxgundong {
		height: 234px;
		overflow-y: auto;
	}

	.yxgundong::-webkit-scrollbar {
		display: none;
	}

	.h-formLines {
		padding: 30px 48px;
	}

	.xuqiuBoxList {
		width: 100%;
		margin-top: 30px;
		display: flex;
		justify-content: space-between;
	}

	.xuqiuBoxList .xuqiulist {
		width: 215px;
		height: 62px;
		border-radius: 4px;
		background: #fff;
		border: 1px solid #959595;
		text-align: center;
		line-height: 62px;
		color: #989898;
		cursor: pointer;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.xuqiuBoxList .xuqiulist.active {
		background: #238cfd;
		border: 1px solid #238cfd;
		color: #fff;
	}
</style>
<style>
	/*.guanhuaibox .el-image , .guanhuaibox .el-image-viewer__wrapper{
		z-index: 9999999999!important;
	}*/
	.h-calenderSign span:last-child {
		margin-right: 0
	}

	.h-dialog .el-dialog__headerbtn .el-dialog__close {
		height: 0.42rem;
		width: 0.42rem;
		line-height: 0.42rem;
		font-size: 0.34rem;
	}

	.fenyes .h-pagiLabel {
		display: none;
	}

	.fenyes .el-pagination .el-pagination__sizes {
		display: none;
	}

	.h-formReason .h-formbLine .el-textarea .el-textarea__inner {
		height: 23px !important;
		min-height: none;
	}

	.timeselect .el-date-editor .el-range-separator {
		width: 10%;
		line-height: 0.35rem;
	}

	.h-formBorder .timeselect .el-input__inner {
		padding-right: 0.1rem;
	}

	/* .h-formBorder .timeselect .el-form-item__content {
		line-height: 0.2rem;
	} */

	.h-formBorder .timeselect .el-date-editor .el-range-separator {
		width: 8%;
		line-height: 0.35rem;
	}
	.ljjcalendar .el-calendar-table .el-calendar-day{
		height: 1.08rem;
		padding: 0.06rem;
	}
</style>
<style scoped lang="scss">
	.bottomTip {
		position: absolute;
		left: 49.7%;
		bottom: 0.3rem;
		transform: translateX(-50%);
	}

	.newtext{
		font-size: 0.28rem;
		color: white;
		position: absolute;
		top:0.2rem;
		left: 50%;
		transform: translateX(-50%);
		font-weight: bold;
		text-shadow:1px 1px 4px #2785E7;
		z-index: 2;
	}

	.leaderBox {
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.4);
		position: fixed;
		z-index: 99999;
		overflow: hidden;
		top: 0;
		left: 0;

		.leaderbg {
			width: 100%;
			height: 100%;
		}

		.steps {
			position: absolute;
			z-index: 1;
		}

		.step1 {
			top: 0.8rem;
			left: 0rem;
			width: 5.65rem;
			height: 20rem;
		}

		.step2 {
			top: 1.5rem;
			left: 5.3rem;
			width: 3.5rem;
			height: 2.53rem;
		}

		.step3 {
			top: 1.5rem;
			right: 2.7rem;
			width: 3rem;
			height: 2.53rem;
		}

		.step4 {
			top: 1.5rem;
			right: 0rem;
			width: 3rem;
			height: 2.53rem;
		}

		.step5 {
			top: 2rem;
			right: 7.1rem;
			width: 2rem;
			height: 1.5rem;
		}

		.step6 {
			top: 2rem;
			left: 2.8rem;
			width: 14.5rem;
			height: 7rem;
		}

		.step7 {
			top: 6.9rem;
			left: 2.95rem;
			width: 9rem;
			height: 2rem;
		}

		.step8 {
			top: 6.15rem;
			left: 15.7rem;
			width: 2rem;
			height: 1.4rem;
		}

		.step9 {
			top: 7.55rem;
			left: 2.7rem;
			width: 1.62rem;
			height: 1.7rem;
		}

		.stepbtn {
			width: 1.9rem;
			height: 0.6rem;
			border: 0.03rem solid #FFFFFF;
			background-color: rgba(0, 0, 0, 0.1);
			border-radius: 5px;
			display: flex;
			justify-content: center;
			line-height: 0.5rem;
			position: absolute;
			z-index: 99;
			bottom: 0.65rem;
			left: 50%;
			transform: translateX(-50%);
			font-size: 0.27rem;
			letter-spacing: 2px;
			color: white;
			cursor: pointer;
		}

		.closeIt {
			width: 0.3rem;
			height: 0.3rem;
			position: absolute;
			top: 0.2rem;
			right: 0.2rem;
			cursor: pointer;
		}
	}
</style>
